import { render, staticRenderFns } from "./BtnAtualizar.vue?vue&type=template&id=64488a1a&"
import script from "./BtnAtualizar.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports